// extracted by mini-css-extract-plugin
export default {"input":"Search_input__klILD","icon":"Search_icon__XMmYc","clear":"Search_clear__q6EIX"};